import { IconVideo16 } from '@cian/ui-kit';

import { FC } from 'react';

import { nbspJsString } from 'shared/constants/symbols';

import { FeatureLabel, FeatureLabelTooltipPlacement } from '../FeatureLabel';

type HasVideoBadgeProps = {
  placement?: FeatureLabelTooltipPlacement;
};

export const HasVideoBadge: FC<HasVideoBadgeProps> = props => {
  const { placement } = props;

  return (
    <FeatureLabel
      dataTestId="card-gallery.video-badge"
      icon={<IconVideo16 color="white_100" />}
      placement={placement}
      title={`Объявление${nbspJsString}с${nbspJsString}видео`}
    />
  );
};
